<script>
  import * as d3 from "d3";

  export let evictions = [];

  let streets_data = [];
  let rows = [];

  $: streets_data = Array.from(d3.group(evictions, (d) => d.street));

  $: rows = streets_data.map((d) => {
    return { address: d[0], count: d[1].length };
  });

  let address_sorted = [];
  $: if (rows.length != 0) {
    address_sorted = rows.sort(compare);
  }

  let current_sort = "compare";

  function compare(a, b) {
    if (a.count > b.count) {
      return -1;
    }
    if (a.count < b.count) {
      return 1;
    }
    return 0;
  }

  function inverseCompare(a, b) {
    if (a.count < b.count) {
      return -1;
    }
    if (a.count > b.count) {
      return 1;
    }
    return 0;
  }

  function toggleSort() {
    // console.log('clicked')
    if (current_sort === "compare") {
      address_sorted = rows.sort(inverseCompare);
      current_sort = "inverseCompare";
    } else {
      address_sorted = rows.sort(compare);
      current_sort = "compare";
    }
  }
</script>

<div>
  <h3>Address Count</h3>
  <div class="table">
    <table style="width:100%">
      <thead>
        <tr>
          <th class="header">Street</th>
          <th class="header" id="count-header" on:click={toggleSort}
            >Count
            <i class="fa fa-sort" style="margin-left:5px" />
          </th>
        </tr><tr />
      </thead>
      <tbody>
        {#each address_sorted as row, i}
          <tr style={`background:${i % 2 === 1 ? "#f0f0f0" : "white"}`}>
            <td class="data">{row.address}</td>
            <td class="data">{row.count}</td>
          </tr>
        {/each}
      </tbody>
    </table>
  </div>
</div>

<style>
  .table {
    height: 36vh;
    overflow: scroll;
  }

  .header {
    font-size: 12px;
    text-align: left;
    border-bottom: 1px solid gray;
  }

  #count-header {
    cursor: pointer;
  }

  .data {
    font-size: 12px;
  }
</style>
